import { TrackedSelect } from '@objectiv/tracker-react';
import clsx from 'clsx';

import * as styles from './TocMobile.module.css';

type TocMobileProps = {
  headings: string[];
  activeSectionIndex: number;
  onSelect: (index: number) => void;
  className?: string;
};

export const TocMobile: React.FC<TocMobileProps> = ({ headings, activeSectionIndex, onSelect, className }) => (
  <div className={clsx(styles.tocMobile, className)}>
    <TrackedSelect
      objectiv={{ id: 'toc-mobile' }}
      className={styles.select}
      value={headings[activeSectionIndex]}
      onChange={(event) => {
        const index = headings.findIndex((heading) => heading === event.target.value);
        onSelect(index);
      }}
    >
      {headings.map((heading) => (
        <option key={heading} value={heading}>
          {heading}
        </option>
      ))}
    </TrackedSelect>
  </div>
);
